<template>
    <form @submit.prevent="submitForm">
        <div class="row">
            <div class="col-md-6">
                <field-text required v-model="form.title_fa" label="عنوان فارسی" placeholder=""/>
                <field-markdown required v-model="form.description_fa" label="توضیحات - فارسی" placeholder=""/>
                <field-select-tree required v-model="form.tree_parent" label="انتخاب دسته بندی" placeholder=""
                                   :radio="true" link="/fa/v1/product-categories/tree"/>

                <field-image required v-model="form.image_src" link="/fa/v1/product-categories/upload-image"
                             placeholder="" :ratio="1.77"/>
            </div>
            <div class="col-md-6">
                <field-text required v-model="form.title_en" label="عنوان انگلیسی" placeholder=""/>

                <field-markdown required v-model="form.description_en" label="توضیحات - انگلیسی" placeholder=""/>


                <field-color required v-model="form.color" label=" رنگ" placeholder=""/>
                <field-image required v-model="form.background_src" link="/fa/v1/product-categories/upload-image"
                             placeholder="" :ratio="1.77"/>

            </div>
        </div>

        <alert :success="success" :danger="danger"></alert>
        <button-submit title="ثبت"/>
    </form>
</template>

<script>
import ButtonSubmit from "../ButtonSubmit";
import Alert from "../Alert";
import FieldPassword from "../fields/FieldPassword";
import FieldMobile from "../fields/FieldMobile";
import FieldEmail from "../fields/FieldEmail";

import mixinForm from "../../mixins/mixinForm";
import FieldSelect from "../fields/FieldSelect";
import FieldText from "../fields/FieldText";
import FieldImage from "../fields/FieldImage";
import FieldTextarea from "../fields/FieldTextarea";
import FieldSelectTree from "../fields/FieldSelectTree";
import FieldColor from "../fields/FieldColor";
import FieldMarkdown from "../fields/FieldMarkdown";

export default {
  mixins: [mixinForm],
  components: {
    FieldMarkdown,
    FieldColor,
    FieldSelectTree,
    FieldTextarea,
    FieldImage,
    FieldSelect,
    FieldText,
    FieldEmail,
    FieldMobile,
    FieldPassword,
    Alert,
    ButtonSubmit
  },

  name: "FormProductCategory",
  data() {
    return {
      action: "/fa/v1/product-categories"
    };
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/forms/FormProductCategory.vue